"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const noOrders_webp_1 = __importDefault(require("./assets/images/dashboard/noOrders.webp"));
const LoadingSpinner_1 = __importDefault(require("./components/general/LoadingSpinner"));
const StyledErrorText_1 = require("./components/Dashboard/StyledErrorText");
const StyledGraphic_1 = require("./components/Dashboard/StyledGraphic");
const StyledGreyText_1 = require("./components/Dashboard/StyledGreyText");
const StyledHeader_1 = require("./components/Dashboard/StyledHeader");
const StyledMediumText_1 = require("./components/Dashboard/StyledMediumText");
const StyledMessageContainer_1 = require("./components/Dashboard/StyledMessageContainer");
const react_bootstrap_1 = require("react-bootstrap");
const loadingAndErrorHandlingCopy = {
    fetchError: 'The server could not be reached, please try again later',
    loading: 'Loading',
    noRecordsHeader: 'No Records found',
    noRecordsParagraph: "We didn't find any records."
};
const minLoadingDuration = 200;
const emptyContainer = (c) => react_1.default.createElement(react_1.default.Fragment, null, c);
function handleMinimumTimeToShowLoadingIndicator(loading) {
    const now = () => new Date().getTime();
    const [displayLoading, setDisplayLoading] = (0, react_1.useState)(false);
    const [startedLoadingAt, setStartedLoadingAt] = (0, react_1.useState)(null);
    const [finishedLoadingAt, setFinishedLoadingAt] = (0, react_1.useState)(null);
    const [loadingIndicatorInDOM, setLoadingIndicatorInDOM] = (0, react_1.useState)(false);
    // These useEffects manage the loading indicator so it is shown for at least minLoadingDuration ms.
    // This prevents a "flicker" when we're loading data from the network.
    (0, react_1.useEffect)(() => {
        if (loading) {
            setLoadingIndicatorInDOM(true);
            setFinishedLoadingAt(null);
            setStartedLoadingAt(now());
            setDisplayLoading(true);
        }
        else {
            // no longer loading
            setFinishedLoadingAt(now());
            // remove loading indicator from the DOM so it doesn't
            // take up space after being hidden by the fade out
            setLoadingIndicatorInDOM(false);
        }
    }, [loading]);
    (0, react_1.useEffect)(() => {
        if (!finishedLoadingAt) {
            return;
        }
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        const loadingDuration = finishedLoadingAt - startedLoadingAt;
        if (loadingDuration > minLoadingDuration) {
            setDisplayLoading(false);
        }
        else {
            const stopLoadingIn = minLoadingDuration - loadingDuration;
            setTimeout(() => {
                setDisplayLoading(false);
            }, stopLoadingIn);
        }
    }, [finishedLoadingAt, startedLoadingAt]);
    return [displayLoading, loadingIndicatorInDOM];
}
function computeIsLoading(displayLoading, data, searched) {
    return (displayLoading || !data) && !searched;
}
/*
  renderWithLoadingAndErrorHandling
    key - required, string of path to display in `data` - think "customers", "customers.orders", etc.
    success - required, function to execute on successful fetch of data (must return JSX.Element)

    container - optional, when present, it will invoke the `container` function with `success()` as the argument. This is helpful for putting data, loading indicator, etc. inside of something like a modal

    error - required, but auto-injected in tokenHeader
    loading - required, but auto-injected in tokenHeader
    data - required, but auto-injected in tokenHeader

    copy - optional, comes with defaults

    searched - optional, should be true if user has searched (i.e., Customers/Orders we show a different error message if searched and 0 results vs 0 results total in the DB)
*/
// This looks like a lot of arguments, but we auto-inject a lot of them in `tokenHeader.js`
function renderWithLoadingAndErrorHandling({ container = emptyContainer, copy: { noRecordsHeader, noRecordsImage, noRecordsParagraph } = {
    noRecordsHeader: loadingAndErrorHandlingCopy.noRecordsHeader,
    noRecordsImage: noOrders_webp_1.default,
    noRecordsParagraph: loadingAndErrorHandlingCopy.noRecordsParagraph
}, data, error, key, loading, searched, success }) {
    const [displayLoading, loadingIndicatorInDOM] = handleMinimumTimeToShowLoadingIndicator(loading);
    function displayError(apiError) {
        if (apiError.message.includes('ECONNREFUSED') ||
            apiError.message.toLowerCase().includes('failed')) {
            return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, loadingAndErrorHandlingCopy.fetchError));
        }
        return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, apiError.message));
    }
    function renderLoading() {
        return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
            react_1.default.createElement(LoadingSpinner_1.default, null),
            react_1.default.createElement(StyledMediumText_1.StyledMediumText, { className: 'loading', role: 'paragraph' }, loadingAndErrorHandlingCopy.loading)));
    }
    function renderNoRecords() {
        return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
            react_1.default.createElement(StyledGraphic_1.StyledGraphic, { alt: '', src: noRecordsImage }),
            react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header no-records', role: 'heading' }, noRecordsHeader),
            react_1.default.createElement(StyledGreyText_1.StyledGreyText, { className: 'no-records-paragraph', role: 'paragraph' }, noRecordsParagraph)));
    }
    const hasError = error;
    const isLoading = computeIsLoading(displayLoading, data, searched);
    const noRecords = !displayLoading && !searched && data && lodash_1.default.get(data, key).edges.length === 0;
    // container allows us to put loading indicators, etc. _inside_ of a modal - reduces jumping when data is loaded
    return container(react_1.default.createElement(react_1.default.Fragment, null,
        loadingIndicatorInDOM && react_1.default.createElement(react_bootstrap_1.Fade, { in: isLoading }, renderLoading()),
        react_1.default.createElement(react_bootstrap_1.Fade, { in: !isLoading },
            react_1.default.createElement("div", null,
                hasError ? displayError(error) : null,
                noRecords ? renderNoRecords() : null,
                !hasError && !isLoading && !noRecords ? success() : null))));
}
exports.default = renderWithLoadingAndErrorHandling;
